import * as types from '../constants/officeRunnerConstants'

export default function latLng(state = { lat: null, lng: null }, action) {
  switch (action.type) {
    case types.GEOCODE_LATLNG_SUCCESS:
      return action.latLng ? action.latLng : state
    default:
      return state
  }
}


// WEBPACK FOOTER //
// ./src/reducers/latLngReducer.js